import './Page404Config';
import ErrorPage404 from '../ErrorPage404';

const Page404: React.FC = () => <ErrorPage404 />;

export default Page404;
